import { AppHealthPage } from './AppHealthPage'

export const PerfectDay = () => {
  return <AppHealthPage appName="perfectday" displayName="Perfect Day" />
}

export default PerfectDay
